import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { CirclePlayIcon, RightArrowCircleIcon } from 'images'
import { getYoutubeThumbnailUrl } from 'domain/adPreview/format'

// Bare full-bleed card: media fills the card, dark gradient overlay at the
// bottom, left-aligned logo/headline/description, circular white arrow CTA —
// no surrounding app chrome. Used for the 9:16 placement, one of the 1.91:1
// mobile-card skins, and one of the Video/General skins (Figma nodes
// 31509:16089, 31518:16545, 31518:16562 — see googleDisplayVariations.js).
const BareGradientCard = ({ ad }) => {
  const { headline, description, media, logo, businessName } = ad
  const isYoutube = Boolean(media?.youtube_video_id)
  const aspectRatio = media?.width && media?.height ? `${media.width} / ${media.height}` : '1.91 / 1'

  return (
    <div className="google-display-card google-display-card--gradient" style={{ aspectRatio }}>
      {media?.youtube_video_id ? (
        // See YoutubeChromeCard.jsx — a real youtube_video_id item has no
        // `url`, so render YouTube's public thumbnail instead.
        <LazyLoadImage
          className="google-display-card__media"
          src={getYoutubeThumbnailUrl(media.youtube_video_id)}
          alt={media?.filename}
          visibleByDefault
        />
      ) : (
        // visibleByDefault: skips the IntersectionObserver placeholder, which
        // otherwise renders as a <span> sized via inline style from the raw
        // width/height props (not CSS) — invisible normally, but inflates a
        // horizontally-scrolling row's height for any card not yet scrolled
        // into view (10-card 1.91:1 row). These are small always-in-modal
        // thumbnails with no real lazy-load benefit.
        <LazyLoadImage
          className="google-display-card__media"
          src={media?.url}
          alt={media?.filename}
          width={media?.width}
          height={media?.height}
          visibleByDefault
        />
      )}
      {isYoutube && <CirclePlayIcon className="google-display-card__play" />}
      <div className="google-display-card__gradient" />
      <div className="google-display-card__content">
        {logo?.url && <img className="google-display-card__logo" src={logo.url} alt={businessName} />}
        <div className="google-display-card__headline">{headline}</div>
        <div className="google-display-card__description">{description}</div>
      </div>
      <button type="button" className="google-display-card__cta-circle" aria-label={ad.callToAction}>
        <RightArrowCircleIcon />
      </button>
    </div>
  )
}

BareGradientCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    callToAction: PropTypes.string,
    media: PropTypes.object,
    logo: PropTypes.object,
    businessName: PropTypes.string,
  }).isRequired,
}

export default BareGradientCard
